import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Button from '../../button'
import { IconNext, IconPrevious } from '../../icons'

import './index.styl'

const FinancialReport = ({ pageData, screen }) => {
  const { t } =  useTranslation()

  const [yearReport, setYearReport] = useState([])
  const [seasonReport, setSeasonReport] = useState([])
  const [activeSeason, setActiveSeason] = useState(1)

  useEffect(() => {
    setYearReport(pageData.monthlyRevenue.reverse())
    setSeasonReport(pageData.financialReport.reverse())
  }, [])

  return (
    <div className="finacial-report investor__main">
      <h2 className="investor__title">{t("financialReport.seasonReportTitle")}</h2>
      {
        screen === 'xs' ? (
          <table className="investor__table finacial-report__mb-40">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('financialReport.seasonReport.year')}</th>
                <th className="investor__table-th finacial-report__th-season">
                  <Button
                    style="outline-secondary"
                    disabled={activeSeason <= 1}
                    onClick={() => setActiveSeason(activeSeason - 1)}
                    className="finacial-report__previous-season-btn"
                  >
                    <IconPrevious mode="triangle" />
                  </Button>
                  {t(`financialReport.seasonReport.season_${activeSeason}`)}
                  <Button
                    style="outline-secondary"
                    disabled={activeSeason >= 4}
                    onClick={() => setActiveSeason(activeSeason + 1)}
                    className="finacial-report__next-season-btn"
                  >
                    <IconNext mode="triangle" />
                  </Button>
                </th>
              </tr>
            </thead>
            <tbody>
              {
                seasonReport.sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        {d.year}
                      </td>
                      <td className="investor__table-td">
                        {
                          d[`season${activeSeason}`] && d[`season${activeSeason}`][0].name !== "null" && d[`season${activeSeason}`][0].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d[`season${activeSeason}`][0].file_name}`}
                              target="_blank"
                            >
                              {d[`season${activeSeason}`][0].name}
                            </a>
                          )
                        }
                        {
                          d[`season${activeSeason}`] && d[`season${activeSeason}`][1].name && d[`season${activeSeason}`][1].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d[`season${activeSeason}`][1].file_name}`}
                              target="_blank"
                            >
                              {d[`season${activeSeason}`][1].name}
                            </a>
                          )
                        }
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        ) : (
          <table className="investor__table finacial-report__mb-40">
            <thead className="investor__table-thead">
              <tr className="investor__table-tr">
                <th className="investor__table-th">{t('financialReport.seasonReport.year')}</th>
                <th className="investor__table-th">{t('financialReport.seasonReport.season_1')}</th>
                <th className="investor__table-th">{t('financialReport.seasonReport.season_2')}</th>
                <th className="investor__table-th">{t('financialReport.seasonReport.season_3')}</th>
                <th className="investor__table-th">{t('financialReport.seasonReport.season_4')}</th>
              </tr>
            </thead>
            <tbody>
              {
                seasonReport.sort((a, b) => (a.sort - b.sort) )
                  .map((d,i) => (
                    <tr 
                      key={d._id}
                      className={classNames('investor__table-tr', {
                        'investor__table-tr--odd': i%2 === 0
                      })}
                    >
                      <td className="investor__table-td">
                        {d.year}
                      </td>
                      <td className="investor__table-td">
                        {
                          d.season1 && d.season1[0].name !== "null" && d.season1[0].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season1[0].file_name}`}
                              target="_blank"
                            >
                              {d.season1[0].name}
                            </a>
                          )
                        }
                        {
                          d.season1 && d.season1[1].name && d.season1[1].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season1[1].file_name}`}
                              target="_blank"
                            >
                              {d.season1[1].name}
                            </a>
                          )
                        }
                      </td>
                      <td className="investor__table-td">
                        {
                          d.season2 && d.season2[0].name !== "null" && d.season2[0].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season2[0].file_name}`}
                              target="_blank"
                            >
                              {d.season2[0].name}
                            </a>
                          )
                        }
                        {
                          d.season2 && d.season2[1].name && d.season2[1].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season2[1].file_name}`}
                              target="_blank"
                            >
                              {d.season2[1].name}
                            </a>
                          )
                        }
                      </td>
                      <td className="investor__table-td">
                        {
                          d.season3 && d.season3[0].name !== "null" && d.season3[0].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season3[0].file_name}`}
                              target="_blank"
                            >
                              {d.season3[0].name}
                            </a>
                          )
                        }
                        {
                          d.season3 && d.season3[1].name && d.season3[1].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season3[1].file_name}`}
                              target="_blank"
                            >
                              {d.season3[1].name}
                            </a>
                          )
                        }
                      </td>
                      <td className="investor__table-td">
                        {
                          d.season4 && d.season4[0].name !== "null" && d.season4[0].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season4[0].file_name}`}
                              target="_blank"
                            >
                              {d.season4[0].name}
                            </a>
                          )
                        }
                        {
                          d.season4 && d.season4[1].name && d.season4[1].file_name && (
                            <a 
                              className="finacial-report__link-block" 
                              href={`https://www.duro.com.tw:8088/api/v1.0/financial_report_pdf/${d.season4[1].file_name}`}
                              target="_blank"
                            >
                              {d.season4[1].name}
                            </a>
                          )
                        }
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        )
      }
      <h2 className="investor__title">{t("financialReport.yearReportTitle")}</h2>
      <table className="investor__table">
        <thead className="investor__table-thead">
          <tr className="investor__table-tr">
            <th className="investor__table-th">{t('financialReport.yearReport')}</th>
          </tr>
        </thead>
        <tbody>
          {
            yearReport.sort((a, b) => (a.sort - b.sort) )
              .map((d,i) => (
                <tr 
                  key={d._id}
                  className={classNames('investor__table-tr', {
                    'investor__table-tr--odd': i%2 === 0
                  })}
                >
                  <td className="investor__table-td">
                    <a href={`https://www.duro.com.tw:8088/api/v1.0/monthly_revenue_pdf/${d.file}`} target="_blank">{d.title}</a>
                  </td>
                </tr>
              ))
          }
        </tbody>
      </table>
    </div>
  )
}

FinancialReport.propTypes = {}

export default FinancialReport
